import { MRT_TableInstance } from '@talentmesh/table';
import { Button } from '@talentmesh/ui/components/button';
import { Loader2, Send } from 'lucide-react';
import { useState } from 'react';
import { useInviteCandidateContext } from '../../Contexts/InviteCandidateContext';
import { CandidateRowEntry } from '@/Models/CandidateRowEntry';
import UIStrings from '@/Utils/UIStrings';

interface SendInvitationsButtonProps {
    table: MRT_TableInstance<CandidateRowEntry>;
}

function SendInvitationsButton({ table }: SendInvitationsButtonProps) {
    const [sending, setSending] = useState<boolean>(false);
    const { inviteCandidatesAsync, dirtyCount } = useInviteCandidateContext();
    const disableSendInviteButton = dirtyCount === 0;

    const handleApplicantInvite = async () => {
        setSending(true);
        await inviteCandidatesAsync();
        setSending(false);
        table.resetRowSelection();
    };

    return (
        <Button
            type="button"
            variant="default"
            size="default"
            className="mt-2.5 gap-2 self-end"
            onClick={handleApplicantInvite}
            disabled={disableSendInviteButton || sending}
        >
            {sending ? <Loader2 className="size-4 shrink-0 animate-spin" /> : <Send className="size-4 shrink-0" />}
            {UIStrings.SendInvitationButton}
        </Button>
    );
}

export default SendInvitationsButton;
